import { useMutation } from "@tanstack/react-query";
import usePrivateAxios from "@/common/api/usePrivateAxios";
import { unFormatCurrency } from "@/common/utils/unFormatters";
import { AxiosResponse } from "axios";
import { ErrorResponse } from "@/common/types/errorResponse";
import { NegotiationCounterValidationSchema } from "../schemas/negotiationCounter.schema";

interface UseNegotiationSendToClient {
  negotiationId?: string;
  onSuccess: (response: AxiosResponse) => void,
  onError: (error: ErrorResponse) => void,
}

const useNegotiationSendToClient = ({ negotiationId, onSuccess, onError }: UseNegotiationSendToClient) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['negotiationSendToEstablishment', negotiationId],
    mutationFn: async (form: NegotiationCounterValidationSchema) => {
      const payload = {
        negotiation_products_attributes: form.negotiation_products_attributes.map((formNegotiationProduct) => ({
          id: formNegotiationProduct.id,
          desired_action: formNegotiationProduct.desired_action,
          value: formNegotiationProduct.value ? unFormatCurrency(formNegotiationProduct.value) : undefined,
          observation:
            formNegotiationProduct.desired_action === 'counter'
              ? formNegotiationProduct.counter_observation
              : formNegotiationProduct.desired_action === 'reject'
                ? formNegotiationProduct.reject_observation
                : ''
        })),
      };

      return privateAxios.put(`/client/negotiations/${negotiationId}/send_to_client`, payload);
    },
    onSuccess,
    onError,
  });
};

export default useNegotiationSendToClient;
